import React, { useMemo } from 'react';
import styles from './SkillPaths.module.scss';
import { Doughnut } from 'react-chartjs-2';
import { Grid } from '@material-ui/core';
import { format, parseISO } from 'date-fns';
import { useLearningPathsStore } from '../LearningPaths/LearningPaths.store';

const options = (total) => ({
  plugins: {
    tooltip: {
      enabled: total > 0,
      callbacks: {
        label: function (context) {
          return ` ${context?.label}: ${context?.formattedValue}%`;
        },
      },
    },
    legend: {
      display: false,
    },
  },
  animation: {
    duration: 1,
  },
  maintainAspectRatio: false,
  cutout: '70%',
  radius: '100%',
  cutoutPercentage: 10,
});
const ResumeChart = ({ title = '', skillPath = {}, due = new Date() }) => {
  const { setSelectedRepLearningPathID } = useLearningPathsStore();
  const data = useMemo(() => {
    const fetchChartData = (skillPath) => {
      if (skillPath?.percent_completed) {
        return [
          Math.round(
            (skillPath?.completed_modules * 100) /
              (skillPath.pending_modules + skillPath.completed_modules)
          ),
          Math.round(
            (skillPath?.pending_modules * 100) /
              (skillPath.pending_modules + skillPath.completed_modules)
          ),
        ];
      } else {
        return [1];
      }
    };

    const colors = skillPath?.percent_completed === 0 ? ['#e3e3e3'] : ['#0494FD', '#ECEFF1'];

    return {
      labels: ['Completed', 'Pending'],
      datasets: [
        {
          label: '',
          data: fetchChartData(skillPath),
          backgroundColor: colors,
          borderColor: colors,
          hoverBorderColor: colors,
          hoverBackgroundColor: colors,
          hoverBorderWidth: 0,
          hoverBorderRadius: 0,
          hoverOffset: 6,
          borderWidth: 1,
        },
      ],
    };
  }, [skillPath]);

  return (
    <div className={styles.progressChart}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLine1}>
          <span className={styles.headerPeriod}>Resume</span>
          {due && (
            <span className={styles.headerPeriod}>Due {format(parseISO(due), 'MMM do, yyyy')}</span>
          )}
        </div>
        <span className={styles.headerTitle}>{title}</span>
      </div>
      <div className={styles.bodyChart}>
        <Grid item xs={12} md={12} className={styles.chartDatasets}>
          <ul className="listUnstyled">
            <li className={styles.published}>
              Completed - <strong>{skillPath?.completed_modules}</strong>
            </li>
            <li className={styles.drafts}>
              Pending - <strong>{skillPath?.pending_modules}</strong>
            </li>
            <li
              className={styles.resume}
              onClick={() => {
                setSelectedRepLearningPathID(skillPath?.learning_path?.uuid);
              }}
            >
              Resume Skill Path
            </li>
          </ul>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          style={{ height: '200px', position: 'relative', marginTop: '1.5rem' }}
        >
          <div className={styles.totalContainer}>
            <h6 className="heading1">{skillPath?.percent_completed}%</h6>
            <p className="paragraph">Completion</p>
          </div>
          <Doughnut data={data} options={options(skillPath?.percent_completed)} />
        </Grid>
      </div>
    </div>
  );
};

export default ResumeChart;
